import BillingsOrderTaxiRailyDraftRequest from "../../../../../api/raily/billings/order/taxi-raily/draft/billings-order-taxi-raily-draft.request";
import BillingsOrderTaxiRailyDraftParams from "./billings-order-taxi-raily-draft-params";

const create = (
  params: BillingsOrderTaxiRailyDraftParams,
): BillingsOrderTaxiRailyDraftRequest => {
  return {
    orderId: params.orderId,
  };
};

const billingsOrderTaxiRailyDraftParamsFactory = {
  create,
};

export default billingsOrderTaxiRailyDraftParamsFactory;
